import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { FeeColumnFilterPanelService, PlayerAdjustmentService } from '../../../../services';
import { AlertService } from '../../../../services/alert.service';
import { UpdatePaymentPlan } from '../../../../interfaces/update-payment-plan';
import { PaymentPlans } from '../../../../interfaces/payment-plans';
import * as lodash from 'lodash';
import { StorageUtil } from '../../../../store';

@Component({
  selector: 'app-update-payment-plan',
  templateUrl: './update-payment-plan.component.html',
  styleUrls: ['./update-payment-plan.component.css']
})
export class UpdatePaymentPlanComponent implements OnInit {
  public paymentPlanForm: FormGroup;
  public validationMessages = {};
  public NoOfPayment: number;
  public TotalAmountOfPayment = 0;
  public PartialLogAmount = 0;
  public unPaidFeeDiscount = 0;
  public items: FormArray;
  public today = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
  public payment_installment_amount: number;
  plans: PaymentPlans[];

  @Input() ClubUserProgramFeeID: string;
  @Input() ClubProgramFeeID: string;
  @Input() TotalFeeAmount: number;
  @Input() TotalFeeDiscounts: number;
  @Input() TotalLogPayments: number;

  @Output() refreshEmitter = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService,
    private _alertService: AlertService
  ) {
    this.validationMessages = {
      'Required': 'This field is required.'
    };
  }

  ngOnInit() {
    console.log('TotalLogPayments - ', this.TotalLogPayments);
    this.initForm();
    this.createPaymentsControl(this.ClubUserProgramFeeID);
  }

  initForm() {
    this.paymentPlanForm = this.fb.group({
      items: this.fb.array([])
    });
  }

  validateUi() {
    Object.keys(this.paymentPlanForm.controls).forEach(field => {
      const control = this.paymentPlanForm.get(field);
      console.log('control - ', control);
      control.markAsTouched({ onlySelf: true });
    });
  }

  updateNumberOfPayments(event, index: number, is_paid: boolean) {
    event.preventDefault();

    const RADIX = 10;
    const updatedValue = parseInt(event.target.value, RADIX);
    if (isNaN(updatedValue)) {
    } else {

      // Get Paid Fees
      const paidFees = this.items.value.filter(fee => fee.is_paid === true);

      const paidFeesAmount = paidFees.reduce( function(cnt, o) { return cnt + o.payment_amount; }, 0);
      const paidFeesNumber = paidFees.length;

      const totalFeeAmount = Number(this.TotalAmountOfPayment) - paidFeesAmount - updatedValue;
      const numberOfPayments = Number(this.NoOfPayment) - 1 - paidFeesNumber;
      const payment_installment_amount = totalFeeAmount / numberOfPayments;
      const paymentsLength = Number(this.NoOfPayment);

      if ((this.items.length - paidFees.length) === 1) {
        const lockedValue = Number(this.TotalAmountOfPayment) - paidFeesAmount;
        this.items.at(index).patchValue({ payment_amount: lockedValue });
        this._alertService.info('You can not update this fee');
        return;
      }

      for (let i = 0; i < paymentsLength; i++) {
        if (i !== index && this.items.at(i).value.is_paid === false) {
          this.items.at(i).patchValue({ payment_amount: payment_installment_amount });
        }
      }
    }
  }

  onSubmit(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {

      const requestData: UpdatePaymentPlan = {
        clubUserProgramFeeID: Number(this.ClubUserProgramFeeID),
        paymentFees: this.paymentPlanForm.value.items,
        addedBy: StorageUtil.userID,
        updatedBy: StorageUtil.userID,
        discountValue: lodash.sumBy(this.plans.filter(f => !f.isPaid), 'discountAmount'),
        logPaymentValue: this.TotalLogPayments,
        partialLogAmount: this.PartialLogAmount
      };

      console.log('requestData - ', requestData);

      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.playerAdjustmentService.updatePaymentPlan(requestData).subscribe((data: any) => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        this.clearFormData();
        this.closeSideOverlay();
        this._alertService.success(data.result);
        this.refreshEmitter.emit(true);
      }, error => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        if (typeof(error.error) === 'string') {
          this._alertService.error(error.error);
        } else {
          this._alertService.error('Due Date is a required field');
        }
        this.refreshEmitter.emit(false);
      });

    } else {
      this._alertService.error('Amount field is required');
      this.validateUi();
    }
  }


  clearFormData() {
    this.paymentPlanForm.reset();
  }

  onReset(event) {
    event.stopPropagation();
    this.clearFormData();
    this.closeSideOverlay();
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  addPayment(event, paymentPlanForm) {
    console.log(Date.now().toString());
    event.preventDefault();
    this.items.push(this.createItem('', '', '', '', false, false, false));
    this.NoOfPayment =  this.items.length;

    // Update Values
    this.getPaymentInstallmentAmount();
    this.setFormArray(this.items);
  }

  createItem(feeid, description, amount, duedate, ispaid, isfulllog, ispartiallog, discountAmount = 0):   FormGroup {
      return this.fb.group({
        fee_id: [feeid],
        payment_description: [description],
        payment_amount: [amount, [Validators.required]],
        due_date: [duedate],
        is_paid: [ispaid],
        is_full_log: [isfulllog],
        is_partial_log: [ispartiallog],
        discountAmount: discountAmount
      });
  }

  // TotalAmountOfPayment

  createPaymentsControl(ClubUserProgramFeeID) {
    this.playerAdjustmentService.getPaymentPlans(ClubUserProgramFeeID).subscribe((response) => {

      this.plans = response;
      this.NoOfPayment = Number(response.length);
      if (this.items) {
        this.clearFormArray(this.items);
      }
      this.items = this.paymentPlanForm.get('items') as FormArray;

      console.log('this.items - ', this.items);


      // console.log('this.items - ', this.items);
      this.TotalAmountOfPayment = this.TotalFeeAmount;
      this.unPaidFeeDiscount = this.CalculateUnPaidFeeDiscount(response);

      console.log('TotalAmountOfPayment - ', this.TotalAmountOfPayment);
      console.log('unPaidFeeDiscount - ', this.unPaidFeeDiscount);


      let totalLogPayments = this.TotalLogPayments;

      for (let i = 0; i < this.NoOfPayment; i++) {
        console.log('TotalLogPayments - ', totalLogPayments);
        const updatedAmount = response[i].amount - this.unPaidFeeDiscount;

        if (response[i].isPaid) {
          this.items.push(this.createItem(response[i].clubUserProgramFeeID, response[i].description, response[i].amount, response[i].dueDate, response[i].isPaid, false, false, response[i].discountAmount));
        } else {
          if (totalLogPayments === 0) {
            this.items.push(this.createItem(response[i].clubUserProgramFeeID, response[i].description, response[i].amount, response[i].dueDate, response[i].isPaid, false, false, response[i].discountAmount));
          } else {
            if (updatedAmount < totalLogPayments) {
              totalLogPayments -= updatedAmount;
              this.items.push(this.createItem(response[i].clubUserProgramFeeID, response[i].description, response[i].amount, response[i].dueDate, true, true, false, response[i].discountAmount));
            } else {
              this.items.push(this.createItem(response[i].clubUserProgramFeeID, response[i].description, response[i].amount, response[i].dueDate, true, false, true, response[i].discountAmount));
              this.PartialLogAmount = totalLogPayments;
              this.TotalAmountOfPayment -= this.PartialLogAmount;
              totalLogPayments = 0;
            }
          }
        }
      }
    }, error => {
      console.log('error', error.statusText);
    });
  }

  public CalculateUnPaidFeeDiscount(response: any) {
    const paidFeesNumber = response.filter(fee => fee.isPaid === true).length;

    const unPaidFeesNumber = this.NoOfPayment - paidFeesNumber;
    const discountPerFeeAmount = this.TotalFeeDiscounts / unPaidFeesNumber;

    return discountPerFeeAmount;
  }

  setFormArray = (formArray: FormArray) => {
    if (formArray.length !== 0) {
      for (let i = 0; i < this.NoOfPayment; i++) {
        if (this.items.at(i).value.is_paid === false) {
          this.items.at(i).patchValue({ payment_amount: this.payment_installment_amount });
        }
      }
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  removePayment(event, index: number) {
    event.preventDefault();


    if ((this.items.length - this.items.value.filter(fee => fee.is_paid === true).length) !== 1) {
      this.items.removeAt(index);
      this.NoOfPayment--;
    } else {
      this._alertService.info('You should have at least one payment');
      return;
    }

    this.getPaymentInstallmentAmount();
    this.setFormArray(this.items);
  }

  getPaymentInstallmentAmount() {
    // Get Paid Fees
    const paidFees = this.items.value.filter(fee => fee.is_paid === true);
    const paidFeesAmount = paidFees.reduce( function(cnt, o) { return cnt + o.payment_amount; }, 0);
    const paidFeesNumber = paidFees.length;

    // Get Unpaid Fees
    const FEE_AMOUNT = this.TotalFeeAmount - paidFeesAmount - this.PartialLogAmount; // Remove the Partial LeftOver from the Calculations
    console.log('Get Unpaid Fees - ', FEE_AMOUNT);
    const NO_OF_PAYMENT = this.NoOfPayment - paidFeesNumber;
    this.payment_installment_amount = FEE_AMOUNT / NO_OF_PAYMENT;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/update-payment-plan/update-payment-plan.component.ts